import {
  calculateTimeLeft,
  decodeFirebaseToken,
} from '@/domains/auth/utils/customSession';
import z from 'zod';

export const fetchRemainingSessionTime = async (token: string) => {
  const decodedToken = decodeFirebaseToken(token);
  const timeLeft = calculateTimeLeft(decodedToken.iat);
  if (timeLeft === 0) {
    return {
      remaining: 0,
    };
  }

  // the above prevents us sending an unnecessary request
  // to the backend, if the token has already expired according
  // the local system clock. A false negative is acceptable here if the
  // local clock is out of sync with the server clock. The user will just be logged
  // out.
  // The below is still needed if the above code determines the token has 'time left'
  // this is to prevent a false positive where as otherwise
  // we might falsy believe the session is still valid when it's not.
  const timeLeftResponse = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/api/auth/remaining-session-timeout`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  if (!timeLeftResponse.ok) {
    return {
      remaining: 0,
    };
  }
  const body = await timeLeftResponse.json();
  return z.object({ remaining: z.number() }).parse(body);
};
